import type from './action-type';
import * as Api from 'api/api';
import * as UserAccountAction from './account/action';

export const init = payload => {
  return {
    type: type.INIT,
    payload
  };
};

export const setShopId = payload => {
  return {
    type: type.SET_SHOP_ID,
    payload
  };
};

export const setUsername = payload => {
  return {
    type: type.SET_USERNAME,
    payload
  };
};

export const setCurrentMenuIndex = payload => {
  return {
    type: type.SET_CURRENT_MENU_INDEX,
    payload
  };
};

export const setRecommendList = payload => {
  return {
    type: type.SET_RECOMMEND_LIST,
    payload
  };
};

export const setRecommendPageSize = payload => {
  return {
    type: type.SET_RECOMMEND_PAGE_SIZE,
    payload
  };
};

export const setRecommendPageNum = payload => {
  return {
    type: type.SET_RECOMMEND_PAGE_NUM,
    payload
  };
};

export const fetchRecommendList = ({ pageSize, pageNum }) => {
  return async f => {
    try {
      let { list } = await Api.recommendList({
        pageSize,
        pageNum
      });

      list = list.splice(0,20);

      f(setRecommendList(list));
    } catch (error) {}
  };
};

export const login = ({ username }) => {
  return f => {
    f(setUsername(username));
  };
};

export const logout = callback => {
  return f => {
    f(UserAccountAction.init());
    if (callback) {
      callback();
    }
  };
};
